export const addImage = (payload?: any) => ({
    type: "@saga/ADD_IMAGE",
    payload
});

